const Team = ({ cast, creative }) => (
  <section id="team" className="container pv6 tc mid-gray">
    <h2 className="heading mb4 pb3 purple">Cast & Creative Team</h2>
    <TeamMembers cast={cast} creative={creative} />
  </section>
)

export default Team

/*
 *
 * General
 *
 */

import React, { Fragment } from 'react'
import shortid from 'shortid'

/*
 *
 * Team Members
 *
 */

import Img from '../components/base/Img'

class TeamMembers extends React.Component {
  state = { activeCategory: `Cast` }

  handleFilterClick = event => {
    if (this.state.activeCategory !== event.target.innerHTML) {
      this.setState({ activeCategory: event.target.innerHTML })
    }
  }

  render() {
    const { cast, creative } = this.props
    const { activeCategory } = this.state

    const activeProfiles = activeCategory === `Cast` ? cast : creative

    return (
      <Fragment>
        <Filters category={activeCategory} handleClick={this.handleFilterClick} />

        <div className="ml-auto mr-auto mw7">
          <Profiles
            profiles={activeProfiles}
            cast={cast}
            creative={creative}
            category={activeCategory}
          />
        </div>
      </Fragment>
    )
  }
}

/*
 *
 * Filters
 *
 */

const Filters = ({ category, handleClick }) => (
  <div>
    <button
      onClick={handleClick}
      className={`filter-btn mb3` + (category === `Cast` ? ` active` : ``)}
    >
      Cast
    </button>
    <button
      onClick={handleClick}
      className={
        `filter-btn mb3` + (category === `Creative Team` ? ` active` : ``)
      }
    >
      Creative Team
    </button>
  </div>
)

/*
 *
 * Profiles
 *
 */

const Profiles = ({ profiles, cast, creative, category }) => (
  <ul className="flex flex-wrap justify-center md:nl4">
    {profiles.map(profile => {
      return <Profile key={shortid.generate()} profile={profile} />
    })}
  </ul>
)

/*
 *
 * Profile
 *
 */

import Modal from 'react-modal'
import noScroll from 'no-scroll'

// Repo: https://github.com/reactjs/react-modal
// Docs: http://reactcommunity.org/react-modal/

class Profile extends React.Component {
  state = { modalIsOpen: false }

  componentDidMount = () => {
    // Bind modal to appElement (http://reactcommunity.org/react-modal/accessibility/)
    Modal.setAppElement(`#___gatsby`)
  }

  openModal = () => {
    this.setState({ modalIsOpen: true })
    noScroll.on()
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
    noScroll.off()
  }

  handleEnter = event => event.charCode === 13 && this.openModal()

  render() {
    const { profile } = this.props

    return (
      <Fragment>
        <ThumbnailProfile
          openModal={this.openModal}
          handleEnter={this.handleEnter}
          profile={profile}
        />
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          closeTimeoutMS={700} // match exit animation timing
          overlayClassName="team-modal-overlay fixed fill z-max"
          className="team-modal-content absolute fill z-max ml-auto mr-auto md:mv4 bg-white w-100 mw6"
        >
          <ModalProfile closeModal={this.closeModal} profile={profile} />
        </Modal>
      </Fragment>
    )
  }
}

/*
 *
 * Thumbnail Profile
 *
 */

import Reveal from '../components/Reveal'

const ThumbnailProfile = ({ openModal, handleEnter, profile }) => (
  <li
    role="button"
    tabIndex="0"
    onClick={openModal}
    onKeyPress={handleEnter}
    className="group mt5 ph3 md:pl4 w-100 md:w-30 lg:w-30 cursor-pointer"
  >
    {/* TODO: I'd like to use a button, but it causes a weird jump to the top of the page on close... */}
    {/* <button onClick={openModal} className="absolute fill z-max w-100" /> */}
    <span className="sr-only">Click or press enter to read full bio</span>
    <Reveal
      css={{ opacity: 0, transform: `translateY(40px) scale(.8)` }}
      duration={1}
      offsetTop={-100}
    >
      <div className="relative mb3 ml-auto mr-auto w-60 md:w-90">
        <Img
          sizes={profile.node.thumbnailImage.childImageSharp.sizes}
          alt={profile.node.alt}
          critical={true}
        />
        <p className="flex justify-center items-center absolute fill o-0 group-hover:o-100 br-100 bg-black-50 f4 ttu white animate">
          Read Bio
        </p>
      </div>
      <h3 className="mb1 pt1 md:pt2 f6 fw4 ttu i pink">{profile.node.role}</h3>
      <h4 className="f5 fw4 ttu">{profile.node.name}</h4>
    </Reveal>
  </li>
)

/*
 *
 * Modal Profile
 *
 */

import FaClose from 'react-icons/lib/fa/close'

import HyperLink from '../components/base/HyperLink'

const ModalProfile = ({ closeModal, profile }) => (
  <article onClick={closeModal} className="h-100">
    {/* Keep this button outside of the scrollable nav area to prevent iOS bugs... */}
    <button
      type="button"
      onClick={closeModal}
      className="absolute right-0 pt3 pr3 z-max"
    >
      <span className="sr-only">Close menu</span>
      <FaClose className="f3 pink" />
    </button>

    <div className="scrolling-touch h-100 overflow-auto josefin-sans mid-gray">
      <Img
        sizes={profile.node.modalImage.childImageSharp.sizes}
        alt={profile.node.alt}
        critical={true}
        className="aspect-ratio aspect-ratio--1x1"
      />
      <div className="container pv5">
        {/* Name & role */}
        <h3 className="mb2 tc f5 md:f4 fw4 ttu pink">{profile.node.role}</h3>
        <h4 className="mb4 tc f4 md:f3 fw4 ttu">{profile.node.name}</h4>

        {/* Bio */}
        {profile.node.bio.map(paragraph => {
          return (
            <p
              key={shortid.generate()}
              className="mt3 lh-copy abeezee"
              dangerouslySetInnerHTML={{ __html: paragraph }}
            />
          )
        })}

        {/* Website link */}
        {profile.node.link && (
          <HyperLink href={profile.node.link} className="db mt4 pt3 tc ttu pink">
            Visit artist website
          </HyperLink>
        )}
      </div>
    </div>
  </article>
)



// WEBPACK FOOTER //
// ./src/sections/Team.js